import { quizErrorMessages } from '@repo/lib/messages/quizErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { QuizKey } from './keys';
import { QuizService } from './quizService';

export function useGetQuizMarked(quizId?: string, attemptId?: string, enabled: boolean = true) {
  const getQuizMarked = useQuery({
    queryKey: [QuizKey.QUIZ, quizId, attemptId],
    queryFn: () => QuizService.getMarkedQuiz(quizId, attemptId).then((response) => response.data),
    enabled: !!quizId && !!attemptId && enabled,
  });

  const errorMessage = useErrorMessage(getQuizMarked.error, quizErrorMessages);

  return { ...getQuizMarked, errorMessage };
}
